import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getTireRightsRepository, {
  TireRightsResponse,
} from './getTireRights.repository';

type InitialState = {
  loading: boolean;
  data?: TireRightsResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getTireRights = createAsyncThunk(
  'getTireRights',
  async (): Promise<TireRightsResponse[]> => {
    return await getTireRightsRepository().catch((error) => {
      throw error;
    });
  }
);

const tireRightsSlice = createSlice({
  name: 'getTireRights',
  initialState,
  reducers: {
    tireRightsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTireRights.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getTireRights.fulfilled,
      (state, action: PayloadAction<TireRightsResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getTireRights.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default tireRightsSlice.reducer;
export const { tireRightsReset } = tireRightsSlice.actions;
